import { styled } from '@mui/material'

export const DrawerBody = styled('div')`
  height: 100%;
  overflow-y: auto;
  /* As drawer is setting these borders, it needs to be overwritten */
  & .MuiPaper-root {
    border-top-right-radius: 0 !important;
    border-top-left-radius: 0 !important;
    width: 100% !important;
    box-sizing: border-box;
  }

  & .MuiPaper-root#shift-plan-card {
    padding: 1rem !important;
  }
`
